import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import FaceSlider from './FaceSlider';
import MatchScore from './MatchScore';
import FaceContent from './FaceContent';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  padding: 0;
  margin: 0px auto;
  font-family: 'Avenir-Medium';
`;

const FaceGraphic = () => (
  <Container>
    <FaceSlider />
    <FaceContent />
    <MatchScore />
  </Container>
);
export default observer(FaceGraphic);
